import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import {
  MessageCircle
} from "lucide-react";

interface ServiceCardActionsProps {
  isPremiumProvider: boolean;
  serviceName: string;
  userContactInfo: {
    whatsapp_number: string | null;
  } | null;
  trackContact: (contactType: 'whatsapp' | 'phone' | 'website') => void;
  onWhatsAppClick?: () => void;
}

const ServiceCardActions = ({
  isPremiumProvider,
  serviceName,
  userContactInfo,
  trackContact,
  onWhatsAppClick,
}: ServiceCardActionsProps) => {
  const { t } = useTranslation('common');
  const whatsappNumber = userContactInfo?.whatsapp_number || "";
  const whatsappMessage = encodeURIComponent(
    t('contact.providerWhatsappInquiryMessage', { serviceName })
  );
  const whatsappLink = `https://wa.me/${whatsappNumber.replace(/[^\d]/g, '')}?text=${whatsappMessage}`;

  return (
    <div className="flex gap-2 mt-auto">
      {whatsappNumber && (
        <a
          href={whatsappLink}
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            onWhatsAppClick?.();
            trackContact('whatsapp');
          }}
          className={cn(
            "flex w-full items-center justify-center rounded-md bg-whatsapp px-4 py-2.5 font-medium text-white transition-colors hover:bg-whatsapp-hover"
          )}
        >
          <MessageCircle className="h-4 w-4 mr-2" />
          WhatsApp
        </a>
      )}
    </div>
  );
};

export default ServiceCardActions;
